import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  AddProjectContextType,
  CategoryDataType,
  EditOptionsType,
} from '../../core-utils/helper-utils/recommendedAppsHelper';
import useSnackbar from '../../core-utils/custom-hooks/Snackbar';
import axios from 'axios';
import properties from '../../core-utils/properties';
import {
  RowData,
  Section,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components/organisms/SortableTable';
import { SubParameterDataType } from '../../_components/molecules/AddSubParameter';

export const AddProjectContext = createContext<
  AddProjectContextType | undefined
>(undefined);

export const AddProjectProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);

  const [stepLoading, setStepLoading] = useState<boolean>(false);
  const [egNid, setEgNid] = useState<string>('');
  const [companyName, setCompanyName] = useState<string>('');
  const [typeOfPlan, setTypeOfPlan] = useState<string>('');
  const [categoryData, setCategoryData] = useState<CategoryDataType[]>([]);
  const [rows, setRows] = useState<RowData[] | Section[]>([]);
  const [openEditModal, setOpenEditModal] = useState<boolean>(false);
  const [
    selectedSubParameter,
    setSelectedSubParameter,
  ] = useState<SubParameterDataType>({
    name: '',
    value: '',
  });
  const [
    selectedEditOptions,
    setSelectedEditOptions,
  ] = useState<EditOptionsType>({
    parentRowId: 0,
    mode: 'create',
  });

  const { snackbarState, openSnackbar, handleCloseSnackBar } = useSnackbar();

  const handleSubParameterSave = () => {
    if (selectedEditOptions.mode === 'edit') {
      setRows((prevRows) =>
        (prevRows as RowData[]).map((row) => {
          if (row.id !== selectedEditOptions.parentRowId) {
            return row;
          }

           
          const updatedSubrows = row.subrows?.map((subRow) =>
            subRow.id === selectedEditOptions.subRowId
              ? { ...subRow, ...selectedSubParameter }
              : subRow,
          );

          return {
            ...row,
            subrows: updatedSubrows,
          };
        }),
      );
    } else {
      const newSubParameter = {
        id: Date.now(),
        ...selectedSubParameter,
      };
      setRows((prevRows) =>
        (prevRows as RowData[]).map((row) =>
          row.id === selectedEditOptions.parentRowId
            ? {
                ...row,
                subrows: [...(row.subrows || []), newSubParameter],
              }
            : row,
        ),
      );
    }

    setOpenEditModal(false);
    setSelectedSubParameter({
      name: '',
      value: '',
    });
  };

  const getDueDiligenceStaticDetails = async () => {
    try {
      const response = await axios.get(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getDueDiligenceStaticDetails,
      );
      setCategoryData(response.data?.data);
    } catch (error) {}
  };

  useEffect(() => {
    getDueDiligenceStaticDetails();
  }, []);

  return (
    <AddProjectContext.Provider
      value={{
        egNid,
        setEgNid,
        currentStep,
        setCurrentStep,
        uploadedFiles,
        setUploadedFiles,
        stepLoading,
        setStepLoading,
        companyName,
        setCompanyName,
        typeOfPlan,
        setTypeOfPlan,
        categoryData,
        rows,
        setRows,
        openEditModal,
        setOpenEditModal,
        selectedSubParameter,
        setSelectedSubParameter,
        selectedEditOptions,
        setSelectedEditOptions,
        handleSubParameterSave,
        snackbarState,
        openSnackbar,
        handleCloseSnackBar,
      }}
    >
      {children}
    </AddProjectContext.Provider>
  );
};

export const useAddProjectContext = () => {
  const context = useContext(AddProjectContext);

  if (context === undefined) {
    throw new Error(
      'useAddProjectContext must be used within a AddProjectProvider',
    );
  }
  return context;
};
